<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Equipamento/Equipamentos</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            v-if="isAllowed(3)"
            color="info"
            to="/equipamento/criar"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="equipamentos.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="equipamentos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15],
        }"
      >
        <template v-slot:item.tipo="{ item }">
          {{ item.tipo === 1 ? "Próprio" : "Alugado" }}
        </template>
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <!--<template v-slot:header="{ header }">
          <tr class="grey lighten-3">
            <th>
              <v-icon>filter_list</v-icon>
            </th>
            <th v-for="header in headers" :key="header.text">
              <div v-if="filters.hasOwnProperty(header.value)">
                <v-autocomplete
                  flat
                  hide-details
                  multiple
                  attach
                  chips
                  dense
                  clearable
                  :items="columnValueList(header.value)"
                  v-model="filters[header.value]"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 8">
                      <span>
                        {{ item }}
                      </span>
                    </v-chip>
                    <span v-if="index === 8" class="grey--text caption">
                      (+{{ filters[header.value].length - 8 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </div>
            </th>
          </tr>
        </template>-->
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(3)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { downloadLista } from "../../../services/equipamentoService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaequipamentos",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Equipamento", value: "familia" },
        { text: "Modelo", value: "modelo" },
        { text: "Marca", value: "marca" },
        { text: "Prefixo", value: "prefixo" },
        { text: "Apelido", value: "apelido" },
        { text: "Proprietário", value: "proprietario" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        modelo: [],
        marca: [],
        prefixo: [],
        proprietario: [],
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
    };
  },
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    filteredList() {
      if (this.showAtivo === false) {
        var newList = this.equipamentos.filter((e) => {
          return (
            ((e.modelo || "").toLowerCase().includes(this.search.toLowerCase()) ||
              (e.marca || "").toLowerCase().includes(this.search.toLowerCase()) ||
              (e.familia || "").toLowerCase().includes(this.search.toLowerCase()) ||
              (e.apelido || "").toLowerCase().includes(this.search.toLowerCase()) ||
              (e.proprietario || "")
                .toLowerCase()
                .includes(this.search.toLowerCase()) ||
              e.prefixo.toLowerCase().includes(this.search.toLowerCase())) &&
            e.ativo === true
          );
        });
        return newList
          .filter((d) => {
            return Object.keys(this.filters).every((f) => {
              return (
                this.filters[f].length < 1 || this.filters[f].includes(d[f])
              );
            });
          })
          .sort(function (a, b) {
            return b.id - a.id;
          });
      } else {
        var novaLista = this.equipamentos.filter((e) => {
          return (
            (e.modelo || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (e.marca || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (e.familia || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (e.apelido || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (e.proprietario || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (e.prefixo || "").toLowerCase().includes(this.search.toLowerCase())
          );
        });
        return novaLista
          .filter((d) => {
            return Object.keys(this.filters).every((f) => {
              return (
                this.filters[f].length < 1 || this.filters[f].includes(d[f])
              );
            });
          })
          .sort(function (a, b) {
            return b.id - a.id;
          });
      }
    },
  },
  methods: {
    ...mapActions("equipamento", [
      "atualizarEquipamentos",
      "atualizarEquipamento",
    ]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("familia", ["atualizarFamilias"]),
    ...mapActions("marcaEquipamento", ["atualizarMarcaEquipamentos"]),
    ...mapActions("modelo", ["atualizarModelos"]),
    ...mapActions("grupoEquipamento", ["atualizarGrupoEquipamentos"]),
    ...mapActions("equipamento", ["atualizarProprietarios"]),
    ...mapActions("equipamento", ["atualizarImplementos"]),
    ...mapActions("equipamento", ["atualizarAcessorios"]),
    editar(equipamento) {
      this.atualizarEquipamento(equipamento);
      if (this.isAllowed(3)) {
        this.$router.push({
          path: "/equipamento/editar",
          query: { ...this.$route.query, id: equipamento.id, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/equipamento/ver",
          query: { ...this.$route.query, id: equipamento.id, page: String(this.options?.page || 1) },
        });
      }
    },
    baixarlista() {
      downloadLista();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarEquipamentos();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    doAjax() {
      if (!this.familias || this.familias.length == 0) {
        this.atualizarFamilias();
      }
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.marcaEquipamentos || this.marcaEquipamentos.length == 0) {
        this.atualizarMarcaEquipamentos();
      }
      if (!this.modelos || this.modelos.length == 0) {
        this.atualizarModelos();
      }
      if (!this.grupoEquipamentos || this.grupoEquipamentos.length == 0) {
        this.atualizarGrupoEquipamentos();
      }
      if (!this.proprietarios || this.proprietarios.length == 0) {
        this.atualizarProprietarios();
      }
      if (!this.implementos || this.implementos.length == 0) {
        this.atualizarImplementos();
      }
      if (!this.acessorios || this.acessorios.length == 0) {
        this.atualizarAcessorios();
      }
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },
    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    this.obterLista();
    this.doAjax();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
  components: {
    TabNavegacaoEquipamento: () => import("../../Tabs/TabCadastroEquipamento"),
  },
};
</script>